import React from 'react';
import { isHttp, isSpecialScheme } from '@/lib/sanity/portable-text/utils/linkHref';
import { AnchorLink } from '@/components/ui/AnchorLink';

export type LinkRendererProps = {
    href: string;
    title?: string;
    target?: '_self' | '_blank';
    className: string;
    children: React.ReactNode;
};

export function LinkRenderer({ href, title, target, className, children }: LinkRendererProps) {
    const external = isHttp(href) || isSpecialScheme(href);
    const openBlank = isHttp(href) && target === '_blank';

    if (external) {
        return (
            <a
                href={href}
                title={title}
                target={openBlank ? '_blank' : undefined}
                rel={openBlank ? 'noopener noreferrer' : undefined}
                className={className}
            >
                {children}
            </a>
        );
    }

    return (
        <AnchorLink href={href} className={className} title={title}>
            {children}
        </AnchorLink>
    );
}
